// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__P-9We","loadingShrink":"PageLoading_loadingShrink__1eC5h"};